/**
 * @desc: 渠道查询
 * @created: 2020/6/1
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http';
import qs from 'qs';

// 获取查询数据接口
export const getListData = params => {
  return request.get('/factoring/list', params)
}

// 新增渠道商
export const saveCreatedChannel = data => {
  return request.post('/factoring/save', data, { json: true })
}

// 获取渠道详情
export const getCompanyDetails = params => {
  return request.get('/factoring/getBankById', params)
}

// 获取作业区域
export const getWorkArea = params => {
  return request.get('/factoring/menu', params)
}

// 修改
export const updateChannelData = data => {
  return request.post('/factoring/update', data, { json: true })
}

// 作业区域选择 
export const getWorkMenu = params => {
  return request.get('/factoring/menu', params)
}

// 获取收单机构
export const getCompany = params => {
  return request.get('/factoring/company', params)
}

// 获取关联通道 
export const checkChannelBind = params => {
  return request.get('/factoring/checkChannelBind', params)
}